'use strict';

/*
Builds the comparison Modal found on compare landing page (vehicle-compare-association-landing)
*/
define('features/compare/compare-landing',[
  'jquery',
  'Handlebars',
  'txt!./compare.landing.hbs',
  'lib/getParameterByName',
  'lib/page-cache',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'lib/scroller',
  'bat',

  // side effect includes
  'bootstrapModal',
  'bootstrapTransition',
  'lib/loader/series',
  'lib/helpers/data-attr',
], function (
  $,
  Handlebars,
  txtTemplate,
  getParameterByName,
  PageCache,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  scroller,
  bat
) {
  var __tmplLanding = Handlebars.compile(txtTemplate);
  var allVehiclesCompare = {
    init: function () {
      this.landingPage.init();
    },

    landingPage: {
      data: {
        brands: [
          'toyota'
        ],

        categories: [
          'cars-n-minivans',
          'trucks',
          'crossovers-n-suvs',
          'hybrids-n-evs'
        ]
      },

      init: function () {
        var lp = allVehiclesCompare.landingPage;
        var compareData = lp.compareData();
        anPageLoad();

        compareData.done(function (compareSeries) {
          lp.series = compareSeries;
          var preset = lp.dataPreset(compareSeries);
          preset.done(function (categorized) {
            categorized.forEach(function (item) {
              // console.log('obj for our HBS: ', item);
              if (item.vehicles.length > 0) {
                $('#js-compare-landing-category').append(__tmplLanding(item));
              }
            });

            bat.util.loader.hideLoader();
            lp.analyticsCats(categorized);
            lp.analyticsSeries();

            // scroll to deep links
            var hash = window.location.hash;
            if (hash.length > 0) {
              hash = hash.replace('#', '#js-deep-');
              // compare page inline hash (ID) ends in an s
              if (hash === '#js-deep-cars-n-minivan') {
                hash = '#js-deep-cars-n-minivans';
              }
              var headerHeight = $('#area-header').outerHeight();
              var offset = $(hash).offset().top - headerHeight;
              $('html, body').animate({
                scrollTop: offset
              }, 500);
            }

            $(document).on('click', '.return-top', function (e) {
              e.preventDefault();
              var $target = $($(this).attr('href'));

              $('body').animate({ scrollTop: $target.offset().top }, 500);
            });

            lp.modalLoader();

            $('.series img, .series h3').attr('tabIndex', '0')
              .keydown(function (event) {
                if (event.keyCode !== 13 && event.keyCode !== 9) {
                  event.preventDefault();
                  return;
                }
                if (event.keyCode === 13) {
                  var $targ = $(event.target);
                  var closest = $targ.closest('.compare-item');
                  $(closest).trigger('click');
                }
              });
            setTimeout(function () {
              lp.checkUrlCompare();
            }, 1000);
          });
        });
      },

      analyticsCats: function analyticsCats(cats) {
        var $scope;
        cats.forEach(function (item) {
          $scope = $('div#js-cat-' + item.code);
          // update hidden links here at same time?
          anAddContext(
            $scope,
            blocks.sectionBlock('compare ' + item.name)
          );
          anClicks($scope);
          scroller.add($scope, {
            after: function viewAfter() {
              anPageLoad($scope, blocks.sectionBlock('compare ' + item.name));
            }
          });
        });

        // add context to each hidden modal link as well
        // console.log('found: ', $('.hidden .link[data-series-code="' + item.code + '"]'));
      },

      analyticsSeries: function analyticsSeries() {
        var seriesArr = this.seriesRaw;
        seriesArr.forEach(function (series) {
          var $scope = $('#compare-landing div[data-series-code="' + series.series_code + '"]');
          anAddContext(
            $scope,
            blocks.seriesBlock({
              series_code: series.series_name,
              year: series.display_year,
              categories: series.categories,
              base_msrp: series.base_msrp
            })
          );
        });
      },

      checkUrlCompare: function () {
        // BAT-2649, BAT-2644 Catch compare links coming from header vehicles
        var compareSeriesCode = getParameterByName('series');
        if (compareSeriesCode) {
          var items = $('.compare-section').find('.compare-item');
          items.each(function () {
            if (compareSeriesCode === $(this).data('seriesCode').toString()) {
              $(this).trigger('click');
            }
          });
        }
      },

      compareData: function () {
        var deferred = $.Deferred();
        var series = [];
        var $vehicleSeries = $('.compare-series-data .vehicle-series');

        $vehicleSeries.each(function (i) {
          var $competitors = $(this).find('.series-competitor');

          var thisSeries = {
            code: $(this).data('seriesCode'),
            name: $(this).data('seriesName'),
            competitors: []
          };

          $competitors.each(function (j) {
            var $self = $(this);

            thisSeries.competitors.push({
              name: $self.data('competitorName'),
              path: $self.data('competitorPath')
            });

            if (j === $competitors.length - 1) {
              series.push(thisSeries);

              if (i === $vehicleSeries.length - 1) {
                deferred.resolve(series);
              }
            }
          });
        });

        return deferred;
      },

      dataPreset: function () {
        var lp = allVehiclesCompare.landingPage;
        var deferred = $.Deferred();

        var results = [];

        $.each(lp.data.brands, function (i, brand) {
          lp.getBrandCategories(brand).then(function (brandCategories) {
            results.push(brandCategories);

            if (i === lp.data.brands.length - 1) {
              lp.mergeBrands(results).then(function (categorized) {
                var ordered;

                $.map(categorized, function (value) {
                  var val = value;
                  switch (val.code) {
                    case 'cars-n-minivans':
                      val.order = 1;
                      break;
                    case 'trucks':
                      val.order = 2;
                      break;
                    case 'crossovers-n-suvs':
                      val.order = 3;
                      break;
                    case 'hybrids-n-evs':
                      val.order = 4;
                      break;
                    default:
                      val.order = 5;
                  }

                  val.vehicles.sort(function (a, b) {
                    return a.seriesName == b.seriesName ? 0 : +(a.seriesName > b.seriesName) || -1;
                  });
                });

                ordered = categorized.sort(function (a,b) {
                  return (a.order > b.order) ? 1 : (a.order < b.order) ? -1 : 0;
                });

                deferred.resolve(ordered);
              });
            }
          });
        });
        return deferred;
      },

      mergeBrands: function (brandsArray) {
        var lp = allVehiclesCompare.landingPage;

        var deferred = $.Deferred();
        var merged = [];

        var mergeVehicles = function (vehicles, destCategory) {
          $.merge(destCategory.vehicles, vehicles);
        };

        $.each(brandsArray, function (i, brandCats) {
          $.each(brandCats, function (j, category) {
            var currentCat;
            if (lp.categoryExists(category.code, merged)) {
              currentCat = $.grep(merged, function (cat) {
                return cat.code === category.code;
              });

              mergeVehicles(category.vehicles, currentCat);
            } else {
              currentCat = {
                code: category.code,
                name: category.name,
                vehicles: []
              };


              mergeVehicles(category.vehicles, currentCat);
              merged.push(currentCat);
            }

            if (i === brandsArray.length - 1 && j === brandCats.length - 1) {
              deferred.resolve(merged);
            }
          });
        });

        return deferred;
      },

      categoryExists: function (categoryCode, categories) {
        var filtered = $.grep(categories, function (category) {
          return category.code === categoryCode;
        });

        return filtered.length === 1;
      },

      getBrandCategories: function () {
        var lp = allVehiclesCompare.landingPage;
        var deferred = $.Deferred();
        var categories = [];
        var baseImgPrefix = '/assets/img/vehicles/';
        var baseImgSuffix = '/default-all-vehicles.png';

        var processData = function (response) {
          var currentCat;
          var registered = [];
          lp.seriesRaw = response.seriesDepthOne.series;

          $.each(response.seriesDepthOne.series, function (k, series) {
            if (series.categories.length > 0) {
              var category;

              $.each(series.categories, function () {
                if ($.inArray(this.code, lp.data.categories) !== -1) {
                  category = this;
                  return false;
                }
              });

              var pushVehicle = function (cat) {
                lp.getVisibility(series.series_code).done(function (isVisible) {
                  if (isVisible && $.inArray(series.series_code, registered) === -1) {
                    cat.vehicles.push({
                      seriesCode: series.series_code,
                      seriesName: series.series_name,
                      imgUrl: baseImgPrefix + series.series_code + baseImgSuffix
                    });

                    registered.push(series.series_code);
                  }
                });
              };

              if (typeof (category) === 'object') {
                if (lp.categoryExists(category.code, categories)) {
                  currentCat = $.grep(categories, function (cat) {
                    return cat.code === category.code;
                  });

                  pushVehicle(currentCat[0]);
                } else {
                  currentCat = {
                    code: category.code,
                    name: category.name,
                    vehicles: []
                  };

                  pushVehicle(currentCat);
                  categories.push(currentCat);
                }
              }

              if (k === response.seriesDepthOne.series.length - 1) {
                deferred.resolve(categories);
              }
            }
          });
        };

        PageCache.await('series.raw')
          .then(function (data) {
            processData(data);
          })
          .catch(function (err) {
            console.warn('err', err);
          });

        return deferred;
      },

      getVisibility: function (seriesCode) {
        var lp = allVehiclesCompare.landingPage;
        var deferred = $.Deferred();
        var match = $.grep(lp.series, function (series) {
          var param = seriesCode.toString();
          var evaluate = series.code.toString();

          return param === evaluate;
        });

        deferred.resolve(match.length > 0);

        return deferred;
      },

      modalLoader: function () {
        var $compareAVModal = $('#av-modal');
        var $linkStorage = $('<div class="hidden"></div>').appendTo($compareAVModal);

        // remove /sites/<tda dir> from local Vehicle Association links
        $compareAVModal
          .find('.compare-links .link')
          .find('a')
          .each(function () {
            this.href = this.href.replace(/\/sites\/[^/]*\//, '/');
          });

        $compareAVModal.find('.compare-links .link').appendTo($linkStorage);

        $('.compare-item').on('click', function (e) {
          e.preventDefault();

          var seriesCode = $(this).data('seriesCode');
          var seriesName = $(this).data('seriesName');

          // Move all our current links to the hidden div
          $compareAVModal.find('.compare-links .link').appendTo($linkStorage);

          // Find the matching links and move them back to our visible area
          $linkStorage
            .find('[data-series-code="' + seriesCode + '"]')
            .appendTo($compareAVModal.find('.compare-links'));
          anAddContext($compareAVModal, blocks.sectionBlock('compare select modal'));
          anClicks($compareAVModal);

          // Update the modal title
          $compareAVModal
            .find('.js-compare-title span')
            .text(seriesName);

          // Show the modal
          $compareAVModal.modal('show');
        });
      }
    }
  };

  return allVehiclesCompare;
});

